module.exports = __webpack_public_path__ + "img/sfz-2.1b9db0a4.png";